import { Component, OnInit, Input } from '@angular/core';
import { LoadingService } from './../../../core/services/loading.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { IndustryDescription, IndustryPurchasedInfo } from 'src/app/model/industry';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { FunctionalityGroup } from 'src/app/model/configuration';
import { MagoWebService } from 'src/app/core/services/mago-web.service';

@Component({
    selector: 'ms-functionality-included',
    templateUrl: './functionality-included.component.html',
    styleUrls: ['./functionality-included.component.scss'],
})
export class FunctionalityIncludedComponent implements OnInit {
    @Input() functionalitygroups: FunctionalityGroup[];
    @Input() editionSelected: string;
    @Input() currentIndustry: IndustryDescription;
    @Input() currIndustryPurchInfo: IndustryPurchasedInfo = new IndustryPurchasedInfo();
    @Input() moduleCode = '';
    @Input() version = '';
    @Input() countrySelected = '';
    @Input() parent = '';

    public loading: boolean = true;
    public cmsObj: CmsObject[];
    public storeObj: CmsObject[];
    public featureDataSheet: CmsObject[];
    public industryconfiguratorObj: CmsObject[];
    public cmsSpecializedUserExplanation: string;
    cmsTecnicalSetupExplanation = '';

    constructor(public loadingService: LoadingService, private workflow: WorkFlowService, public cmsService: CmsService) {}

    async ngOnInit() {
        await this.getCmsObj();
    }

    public async getCmsObj() {
        const lang = this.workflow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(lang, 'industryAlaCarteConfigurator');
        this.storeObj = await this.cmsService.getCmsObj(lang, 'store');
        this.industryconfiguratorObj = await this.cmsService.getCmsObj(lang, 'industryconfigurator');

        this.cmsSpecializedUserExplanation = this.cmsObj.find(
            (x) => x.ContentName == 'industryAlaCarteConfigurator.SpecializedUserExplanation'
        ).ContentTranslation;

        this.cmsTecnicalSetupExplanation = this.cmsObj.find(
            (x) => x.ContentName == 'industryAlaCarteConfigurator.TecnicalSetupExplanation'
        ).ContentTranslation;
    }

    getFeatureDataSheetDetail(fragment: string) {
        return this.cmsService.getFeatureDataSheetDetail(fragment);
    }
}
